<template>
  <div>
    <a-modal width="640px" style="height: 640px" title="已读列表" :visible="visible" :footer="null" @cancel="onClose">
      <a-form-model :form="filterForm" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }" :model="filterForm">
        <a-row :gutter="24">
          <a-col :span="18">
            <a-form-model-item label="用户">
              <a-select v-model="filterForm.creator" show-search placeholder="用户筛选" :filter-option="utils.filterOption" allow-clear @change="handleChange">
                <a-select-option v-for="(user, index) in userData" :key="index" :value="user.id">{{ user.nickname }} </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="4" style="float: right">
            <a-form-model-item>
              <a-button type="primary" @click="handleChange">查询</a-button>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
      <a-table :loading="loading" :pagination="pagination" :columns="columns" size="middle" :data-source="sourceData" row-key="id" @change="handlePageChange">
        <template slot="avatar" slot-scope="text, record">
          <a-avatar v-if="record.creator" :src="record.creator.avatarUrl" />
          <a-avatar v-else icon="user" />
        </template>
      </a-table>
    </a-modal>
  </div>
</template>

<script>
import { queryActionRecord } from '@/api/business/document';

const columns = [
  {
    title: '用户头像',
    scopedSlots: { customRender: 'avatar' }
  },
  {
    title: '用户ID',
    customRender: (_, record) => record.creator.id || '--'
  },
  {
    title: '昵称',
    customRender: (_, record) => record.creator.nickname || '--'
  },
  {
    width: 165,
    title: '已读时间',
    key: 'createdTime',
    dataIndex: 'createdTime'
  }
];

export default {
  data() {
    return {
      columns,
      visible: false,
      loading: true,
      sourceData: [],
      pagination: {
        size: 'small',
        total: 0,
        pageSize: 20, // 每页中显示10条数据
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'], // 每页中显示的数据
        showTotal: total => `共 ${total} 条` // 分页中显示总的数据
      },
      filterForm: {
        targetId: null,
        targetType: 'mrd',
        actionType: 'read'
      },
      userData: []
    };
  },
  computed: {
    // userData() {
    //   // return this.userList;
    //   return this.utils.getUserData(1);
    // }
  },
  methods: {
    onOpen(targetId, targetType) {
      this.userData = this.utils.getUserData(0);

      if (targetType) {
        this.filterForm.targetType = targetType;
      }
      this.visible = true;
      this.sourceData = [];
      this.pagination.current = 1;
      this.filterForm.targetId = targetId;
      this.queryActionRecordList();
    },

    onClose() {
      this.visible = false;
    },

    handleChange() {
      this.loading = true;
      this.pagination.current = 1;
      this.queryActionRecordList();
    },

    queryActionRecordList() {
      queryActionRecord({
        ...this.filterForm,
        creators: [this.filterForm.creator],
        pageSize: this.pagination.pageSize,
        pageNumber: this.pagination.current
      })
        .then(res => {
          this.loading = false;
          this.sourceData = res.data.items;
          this.pagination.total = res.data.total;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    handlePageChange(pagination) {
      this.pagination = pagination;
      this.filterForm.page_size = pagination.pageSize;
      this.filterForm.page_number = pagination.current;
      this.queryActionRecordList();
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .ant-form-item {
  margin-bottom: 8px;
  display: flex;

  .ant-form-item-control-wrapper {
    flex: 1;
  }
}

.filter-data {
  margin-top: 16px;
}
</style>
